import React, { useState } from 'react';
import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import {
  Button,
  TextField,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Checkbox,
  FormControlLabel,
  Typography
} from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';
import RfsStyles from '../rfs/rfs.module.css';
import commonStyle from '../common/common.module.css';

const styles = (theme: Theme) =>
  createStyles({
    inputTextField: {
      width: '100%',
      marginTop: theme.spacing(1)
    },
    errorText: {
      color: 'red',
      marginTop: theme.spacing(1)
    },
    submitBtn: {
      marginTop: theme.spacing(2)
    }
  });

interface Props {
  classes: any;
  modalOpen: boolean;
  originalAwbText: string;
  isImport?: boolean;
  handleClose: () => void;
  proceed: () => void;
}

const ManualAwbConfirmModal = (props: Props) => {
  const { classes, modalOpen, originalAwbText, isImport, handleClose, proceed } = props;
  const [awbValue, setAwbValue] = useState('');
  const [isNotInterline, setIsNotInterline] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');

  const handleChangeText = (e: React.ChangeEvent<HTMLInputElement>) => {
    let text = e.target.value;
    if (text.length === 3 && awbValue.length === 2) {
      text = text + '-';
    }
    if (text.length === 11) {
      if (text.indexOf('-') < 0) {
        text = text.slice(0, 3) + '-' + text.slice(3);
      }
    }
    if (text.split('-').length > 2) {
      return;
    }
    setAwbValue(text);
    setErrorMsg('');
  };

  const handleSubmit = () => {
    if (!isImport && !isNotInterline) {
      setErrorMsg('You must reconfirm that this is not an interline transfer by checking the box.');
      return;
    }
    if (awbValue.replace(/-/g, '') !== originalAwbText.replace(/-/g, '')) {
      setErrorMsg('Awb Number does not match what you originally entered.');
      return;
    }
    proceed();
  };

  return (
    <Dialog
      open={modalOpen}
      onClose={handleClose}
      aria-labelledby='form-dialog-title'
      maxWidth={'sm'}
      fullWidth={true}
    >
      <DialogTitle id='form-dialog-title'>
        <div className={RfsStyles.dialogTitle}>
          <span className={RfsStyles.name}>Confirm Manual AWB Entry</span>
          <IconButton aria-label='Close' className={RfsStyles.close} onClick={handleClose}>
            <CloseIcon color='primary' />
          </IconButton>
        </div>
        <hr />
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" gutterBottom>
          Please reconfirm the following details to proceed with entering this drop-off
        </Typography>

        <div className={`${commonStyle.wrapper} ${RfsStyles.dialogContentWrapper}`}>
          <Typography variant="body2">Re-enter Airwaybill Number</Typography>
          <TextField
            id="awb-confirm"
            value={awbValue}
            onChange={handleChangeText}
            placeholder="e.g. 020-04725464"
            className={classes.inputTextField}
            InputProps={{ disableUnderline: true }}
          />
        </div>

        {!isImport && (
          <FormControlLabel
            control={
              <Checkbox
                checked={isNotInterline}
                onChange={(e) => {
                  setIsNotInterline(e.target.checked);
                  setErrorMsg('');
                }}
                color="primary"
              />
            }
            label={<span className={RfsStyles.checkboxConfirmation}>I confirm that this is not an interline transfer.</span>}
          />
        )}

        {errorMsg && (
          <Typography variant="body2" className={classes.errorText}>
            {errorMsg}
          </Typography>
        )}
      </DialogContent>
      <DialogActions classes={{ root: RfsStyles.dialogActionsRoot }} className={RfsStyles.dialogActions}>
        <Button onClick={handleClose} color="primary" variant='contained'>
          Cancel
        </Button>
        <Button onClick={handleSubmit} color="primary" variant="contained" disabled={(!isImport && !isNotInterline) || !awbValue || awbValue.replace(/-/g, '') !== originalAwbText.replace(/-/g, '')}>
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default withStyles(styles)(ManualAwbConfirmModal);
